import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchProgram } from "../program/slice";
import adapter from "./adapter";
import service from './service'
import dayjs from 'dayjs';

const NAME = "programForm"

const initialFormEmpty = getInitialFormEmpty()

const initialState = {
  _payload: null,
  status: "idle",
  error: "",
  data: initialFormEmpty,

  /**
   * @glossary
   * 'holder' adalah wadah untuk menampung IDs
   * yang akan dikirim ke API terpisah dari parent entity-nya.
   * - deleteHolder: penampung id yang akan dikirim dengan method delete
   * - updateHolder: penampung id yang akan dikirim dengan method put
   */
  holder: {
    journey: {
      create: {},
      update: [],
      delete: []
    },
    milestone: {
      create: {},
      update: [],
      delete: []
    },
    gallery: {
      create: [],
      delete: []
    },
    partner: {
      create: [],
      delete: []
    },
    partner_external: {
      create: [],
      delete: []
    },
    location: {
      create: [],
      delete: []
    },
    report: {
      create: [],
      delete: []
    }
  },

  // Copy from organizationForm slice
  partner: {
    partners: [],
    partners_external: [],
    active_form: 'internal', // internal || external
    form: {},
    partner_external_to_edit: {}
  }
};

export const createProgram = createAsyncThunk(
  `${NAME}/createProgram`,
  async (options) => (
    await service.createProgram(options)
  )
)

export const updateProgram = createAsyncThunk(
  `${NAME}/updateProgram`,
  async (options) => (
    await service.updateProgram(options)
  )
)

export const setPartnerExternalToEdit = createAsyncThunk(
  `${NAME}/setPartnerExternalToEdit`,
  async (options) => options
)

export const reset = createAsyncThunk(
  `${NAME}/reset`,
  async (options) => options
)

export const programFormSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    updateForm(state, action){
      state.data[action.payload.key] = action.payload.value
    },
    addToHolderObject(state, action){
      const { entity, type, key, value } = action.payload
      state.holder[entity][type][key] = value
    },
    addToHolder(state, action){
      const { entity, type, id } = action.payload
      state.holder[entity][type] = [...state.holder[entity][type], id]
    },
    emptyHolder(state, action){
      const {entity, type} = action.payload
      state.holder[entity][type] = []
    },

    // Gallery
    addImageToHolder(state, action){
      const { type, id, blob } = action.payload
      if(type === 'create'){
        state.holder.gallery[type] = [...state.holder.gallery[type], blob]
      } else {
        state.holder.gallery[type] = [...state.holder.gallery[type], id]
      }
    },
    emptyGalleryHolder(state, action){
      const type = action.payload
      state.holder.gallery[type] = []
    },

    // Partner
    setActivePartnerForm(state, action){
      state.partner.active_form = action.payload
    }
  },
  extraReducers: {
    [fetchProgram.fulfilled]: (state, action) => {
      const adapted = adapter.responseBodyToForm(action.payload)
      state.data = adapted
    },
    [setPartnerExternalToEdit.fulfilled]: (state, action) => {
      state.partner.partner_external_to_edit = action.payload
    },
    [reset.fulfilled]: (state, action) => {
      state.data = initialFormEmpty
    }
  }
});

export const {
  setStatus,
  updateForm,
  addToHolderObject,
  addToHolder,
  emptyHolder,

  addImageToHolder,
  emptyGalleryHolder,

  setActivePartnerForm,
} = programFormSlice.actions

export default programFormSlice.reducer;

/**
 * Helpers
 */
export function getInitialFormBasic(){
  return {
    title_en: '',
    title_id: '',
    about_en: 'N/A',
    about_id: 'N/A',
    start_date: dayjs().format('yyyy-MM-DD'),
    end_date: dayjs().format('yyyy-MM-DD'),
    suitable: [],
    approach: [],
    issue: [],
    tags: [],
    officers: [],
    image: null,
    thumbnail: null,
  }
}
export function getInitialFormEmpty(){
  return {
    id: '',
    ...getInitialFormBasic(),
    locations: [],
    milestones: [],
    journeys: [],
    beneficiaries_gender_men: 0,
    beneficiaries_gender_women: 0,
    beneficiaries_gender_difable_men: 0,
    beneficiaries_gender_difable_women: 0,
    surveys: [],
    retention_pre_program_men: 0,
    retention_pre_program_women: 0,
    retention_post_program_men: 0,
    retention_post_program_women: 0,
    // Satisfaction - Static
    satisfaction_very_satisfied: 0,
    satisfaction_satisfied: 0,
    satisfaction_neutral: 0,
    satisfaction_disatisfied: 0,
    satisfaction_very_disatisfied: 0,
    // Satisfaction - Dynamic
    satisfactions: [],
    // NPS - Static,
    nps_detractors: 0,
    nps_passives: 0,
    nps_promoters: 0,
    // NPS- Static v1
    nps_1: 0,
    nps_2: 0,
    nps_3: 0,
    nps_4: 0,
    nps_5: 0,
    nps_6: 0,
    nps_7: 0,
    nps_8: 0,
    nps_9: 0,
    nps_10: 0,
    // NPS - Dynamic
    nps: [],
    cac: '0',
    stories: [],
    events: [],
    resources: [],
    blog: [],
    acceptance_status: null,
    status: null,
    partners: [],
    partners_local: [],
    partners_external: [],
    partners_external_local: [],
    gallery: []
  }
}
